import axios from "axios";
import { getDefaultStore } from "jotai";
import { userAtom } from "./state";
import { v4 as uuidv4 } from "uuid";

const store = getDefaultStore();

const authorPlatformURL = import.meta.env.VITE_AUTHOR_PLATFORM_API_URL;

const axiosInstance = axios.create({
  baseURL: authorPlatformURL,
  //timeout: 15000, // Timeout in milliseconds
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptors for adding authentication tokens
axiosInstance.interceptors.request.use(
  (config) => {
    const user = store.get(userAtom);

    if (user && user.accessToken) {
      config.headers.Authorization = `Bearer ${user.accessToken}`;
    }

    config.headers["correlation_id"] = uuidv4();

    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptors for handling token expiration and unauthorized access
axiosInstance.interceptors.response.use(
  (response) => response, // Pass successful responses through
  (error) => {
    const originalRequest = error.config;

    if (error.response) {
      const status = error.response.status;

      if (status === 401) {
        console.log("Got 401 error, logging out user");
        // Unauthorized: Clear user state and set sessionExpired flag
        store.set(userAtom, (prev) => ({
          ...prev,
          isAuthenticated: false,
          user: null,
          accessToken: null,
          sessionExpired: true, // Set the sessionExpired flag to show the notification on the login page
        }));

        // Redirect to login page
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
